<template>
  <div class="container-fluid">
    <div class="row flex-md-row flex-column">
      <div class="col-md-4 col-12 custom-col-md-4 d-flex align-items-center">
        <div id="myCarousel" class="carousel slide" data-ride="carousel" v-if="images.length > 1">
          <ol class="carousel-indicators">
            <li
              v-for="(image, index) in images"
              :key="index"
              :data-target="'#myCarousel'"
              :data-slide-to="index"
              :class="{ active: index === 0 }"
            ></li>
          </ol>
          <div class="carousel-inner">
            <div
              v-for="(image, index) in images"
              :key="index"
              :class="['carousel-item', { active: index === 0 }]"
            >
              <img :src="image" alt="Image" class="d-block w-100" style="object-fit: cover;" />
            </div>
          </div>
          <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
        <div v-else>
          <img :src="images[0]" alt="Image" class="d-block w-100" style="object-fit: cover;" />
        </div>
      </div>
      <div class="col-md-6 col-12 custom-col-md-6">
        <h4>{{ title }}</h4><br />
        <p class="text-dark-gray" v-html="description"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        require('@/assets/images/news/20/news_02.jpg'),
        //可輪播圖片
        //EX:require('@/assets/images/news/01/news_3.png'),
      ],
      //標題
      title: '【 TSK | AMWC Asia-TDAC 】',
      //內文
      description:
        '    <b> 🌍 國際醫美教育分享｜TSK 線上研討會 </b><br>由 TSK 海外舉辦的國際線上研討會即將登場，邀請來自印尼與菲律賓的專業皮膚科醫師，分享醫美注射的基礎技巧與臨床經驗。<br><br><b>✨ Mastering Fundamental Techniques in Aesthetic Injectables</b><br>🔹 Dr. Stanley Setiawan, Sp.DVE, FINSDV, FAADV - Indonesian Dermatologist <br>🔹 Dr. Jonathan Nevin T. Yu, MD, FPDS, iFAAD - Filipino Dermatologist <br><br><b>✨What is the topic? </b><br>- Anatomical approaches to botulinum toxin injections, including facial assessment.<br>- Cannula injection techniques of subdermal hydration boosters on face and neck.<br><br>📅 日期：2026 年 4 月 8 日 (三)<br>🕖 時間：7:00 PM（JKT Time）<br>📍 線上平台：Zoom Live <a href="https://tinyurl.com/TSK-FD" target="_blank">（please find the link）</a><br><br>🔹 本活動由 TSK 海外主辦，誠摯推薦給關注醫美注射技術的專業人士。<br>歡迎有興趣的醫師與業界夥伴踴躍參與！',
    };
  },
};
</script>

<style scoped>
.custom-col-md-4 {
  flex: 0 0 auto;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-col-md-6 {
  flex: 0 0 auto;
  width: 60%;
}
@media (max-width: 767.98px) {
  .custom-col-md-4,
  .custom-col-md-6 {
    flex: 0 0 auto;
    width: 100%;
  }
}
</style>
